import React from 'react';
import FeaturePage from './FeaturePage';

function CostTrackingPage() {
  return (
    <FeaturePage title="Cost Tracking">
      {/* You can add specific content here later */}
    </FeaturePage>
  );
}

export default CostTrackingPage;